// Importação de todos os serviços
import authService from './authService';
import consumosService from './consumosService';
import faturasService from './faturasService';
import tarifasService from './tarifasService';
import usuariosService from './usuariosService';

// Exportação centralizada de todos os serviços
export {
  authService,
  consumosService,
  faturasService,
  tarifasService,
  usuariosService
};

// Exportação default com objeto contendo todos os serviços
const services = {
  auth: authService,
  consumos: consumosService,
  faturas: faturasService,
  tarifas: tarifasService,
  usuarios: usuariosService
};

export default services;
